<template>
    <div>
        <div>
            <b-link href="#" class="font-weight-bold text-primary" style="border-bottom: 1px solid ;"
                @click="params.onButtonClick(params.data)">
                {{ params.data.description == undefined ? params.data.Description : params.data.description }}
            </b-link>
        </div>
    </div>
</template>

<script>

export default {
};
</script>

<style scoped></style>